import React, { useState } from 'react';

interface SimpleTooltipProps {
    content: string;
    children: React.ReactNode;
}

export function SimpleTooltip({ content, children }: SimpleTooltipProps) {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div className="absolute z-50 px-2 py-1 text-xs font-medium text-white bg-gray-900 rounded-md shadow-lg whitespace-nowrap -top-8 left-1/2 transform -translate-x-1/2 animate-fadeIn">
                    {content}
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 border-4 border-transparent border-t-gray-900" />
                </div>
            )}
        </div>
    );
}
